import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-connections-tab-header',
  templateUrl: './connections-tab-header.component.html',
  styleUrls: ['./connections-tab-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConnectionsTabHeaderComponent implements OnInit {
  /** Groups, Tags, Attributes on the Devices sub-nav */
  @Input() showDeviceAdminLinks = false;
  /** When true, only the devices list route (exact) activates the Devices tab */
  @Input() devicesTabExact = false;

  productType = '';

  constructor(public router: Router) {}

  ngOnInit(): void {
    try {
      const raw = localStorage.getItem('currentUser');
      this.productType = raw ? JSON.parse(raw).productType || '' : '';
    } catch {
      this.productType = '';
    }
  }

  /** Always read from storage so sub-nav appears after login/navigation without stale state */
  get permissionModules(): string[] {
    try {
      const raw = localStorage.getItem('permissionModules');
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  get deviceBase(): string {
    return this.productType === 'BITBREW' ? '/devices' : '/v2/devices';
  }

  get otaBase(): string {
    return this.productType === 'BITBREW' ? '/ota' : '/v2/ota';
  }

  get showDeviceSubNav(): boolean {
    return this.router.isActive(this.deviceBase, false);
  }

  get hasOtaAccess(): boolean {
    return this.permissionModules.includes('OTA') ||
      this.permissionModules.includes('OTA-PARTNER');
  }

  get isOtaPartner(): boolean {
    return this.permissionModules.includes('OTA-PARTNER');
  }

  get showOtaSubNav(): boolean {
    return this.hasOtaAccess &&
      this.router.isActive(this.otaBase, false);
  }

  get showDestinationSubNav(): boolean {
    // Data Hub sub-nav only for OTA-PARTNER accounts
    if (!this.isOtaPartner) {
      return false;
    }
    const path = (this.router.url || '').split('?')[0];
    if (path === '/destinations' || path.startsWith('/destinations/')) {
      return true;
    }
    return this.router.isActive('/destinations', false);
  }

  /** Dashboard vs /dashboard child route (both map to the same screen). */
  get otaDashboardTabActive(): boolean {
    const p = this.router.url.split('?')[0].replace(/\/$/, '') || '/';
    const b = this.otaBase.replace(/\/$/, '');
    return p === b || p === `${b}/dashboard`;
  }
}
